
@switch (matType) {
  @case ('simple') {
    <button mat-button [type]="type" [disabled]="disabled"
      [ngClass]="buttonClass" (click)="onClick.emit($event)"
      [disableRipple]="disableRipple" [ngStyle]="style">
      @if (icon) {
        <ng-icon [class]="iconClass + ' text-xl'" [name]="icon"></ng-icon>
      }
      @if (!!text && !isLoading) {
        <span [class]="textClass">{{ text }}</span>
      }
      @if (!!isLoading) {
        <mat-spinner />
      }
    </button>
  }
  @case ('raised') {
    <button mat-raised-button [type]="type" [disabled]="disabled" [ngClass]="buttonClass"
      (click)="onClick.emit($event)" [disableRipple]="disableRipple" [ngStyle]="style">
      @if (icon) {
        <ng-icon [class]="iconClass + ' text-xl'" [name]="icon"></ng-icon>
      }
      @if (!!text && !isLoading) {
        <span [class]="textClass">{{ text }}</span>
      }
      @if (!!isLoading) {
        <mat-spinner />
      }
    </button>
  }
  @case ('stroked') {
    <button mat-stroked-button [type]="type" [disabled]="disabled" [class]="buttonClass"
      (click)="onClick.emit($event)" [disableRipple]="disableRipple" [ngStyle]="style">
      @if (icon) {
        <ng-icon [class]="iconClass + ' text-xl'" [name]="icon"></ng-icon>
      }
      @if (!!text && !isLoading) {
        <span [class]="textClass">{{ text }}</span>
      }
      @if (!!isLoading) {
        <mat-spinner />
      }
    </button>
  }
  @case ('icon') {
    <button mat-icon-button [type]="type" [disabled]="disabled" [class]="buttonClass"
      (click)="onClick.emit($event)" [disableRipple]="disableRipple" [ngStyle]="style">
      @if (icon) {
        <ng-icon [class]="iconClass + ' text-xl'" [name]="icon"></ng-icon>
      }
      @if (!!text && !isLoading) {
        <span [class]="textClass">{{ text }}</span>
      }
      @if (!!isLoading) {
        <mat-spinner />
      }
    </button>
  }
  @case ('fab') {
    <button mat-fab [type]="type" [disabled]="disabled" [class]="buttonClass"
      (click)="onClick.emit($event)" [disableRipple]="disableRipple" [ngStyle]="style">
      @if (icon) {
        <ng-icon [class]="iconClass + ' text-xl'" [name]="icon"></ng-icon>
      }
      @if (!!text && !isLoading) {
        <span [class]="textClass">{{ text }}</span>
      }
      @if (!!isLoading) {
        <mat-spinner />
      }
    </button>
  }
  @case ('mini-fab') {
    <button mat-mini-fab [type]="type" [disabled]="disabled" [class]="buttonClass"
      (click)="onClick.emit($event)" [disableRipple]="disableRipple" [ngStyle]="style">
      @if (icon) {
        <ng-icon [class]="iconClass + ' text-xl'" [name]="icon"></ng-icon>
      }
      @if (!!text && !isLoading) {
        <span [class]="textClass">{{ text }}</span>
      }
      @if (!!isLoading) {
        <mat-spinner />
      }
    </button>
  }
}
